import { render, staticRenderFns } from "./SliderDialog.vue?vue&type=template&id=6127ba54&scoped=true"
import script from "./SliderDialog.vue?vue&type=script&lang=js"
export * from "./SliderDialog.vue?vue&type=script&lang=js"
import style0 from "./SliderDialog.vue?vue&type=style&index=0&id=6127ba54&prod&scoped=true&lang=css"
import style1 from "./SliderDialog.vue?vue&type=style&index=1&id=6127ba54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6127ba54",
  null
  
)

export default component.exports